import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "field"]
  static values = { showValue: String }

  connect() {
    this.toggle()
  }

  toggle() {
    const match = this.sourceTarget.value === this.showValueValue
    this.fieldTargets.forEach((field) => field.classList.toggle("d-none", !match))
  }
}
